<div class="post-screen-capture">
  <app-loading *ngIf="postLoading$ | async"></app-loading>

  <a
    *ngIf="screenCaptureUrl"
    class="capture"
    [href]="screenCaptureUrl"
    target="_blank"
    rel="noopener"
    [suiTooltip]="'post-screen-capture.tooltip.open-full-size' | translate"
  >
    <img [src]="screenCaptureUrl" appFallbackImage appLazyLoad alt="" />
  </a>

  <div class="no-data" *ngIf="!screenCaptureUrl && !(postLoading$ | async)">
    {{ "post-screen-capture.message.no-screen-capture-available" | translate }}
  </div>
</div>
